// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","476":"component---src-pages-admin-tsx","784":"957c942f"}[chunkId] + "-" + {"245":"28ba1faa2d8682288cb2","453":"e2132bb237c48d84a79b","476":"073e218fad470b74ab65","784":"d038999e0d23603b419b"}[chunkId] + ".js";
};